const themeColor = "#393186";
// export const baseApiUrl = "https://api.vipswallet.com/api";

export const baseApiUrl = "https://api.vipswallet.com/api";

// export const baseApiUrl = "http://webplat.vipswallet.com/api/";
export const shopadminUrl = "http://shopadmin.vipswallet.com";
export const vendorPanelAPi = "http://vendor.vipswallet.com/Login/Vendor";
export const staticTocken = "XMCNBVGDTE734BCU65DW"; //used for getting banners , affiliate etc while calling apis.